import styled, { css } from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop } from 'utils/styles/responsive';

export const IndentTextSectionWrapper = styled.div`
  grid-column: 2/-2;
`;

export const Title = styled.div`
  ${({ theme: { locale } }) => setTypography('heading4', locale)}
  margin-bottom: 30px;
`;

export const Block = styled.div`
  margin-bottom: 100px;
`;

export const Content = styled.div`
  grid-column: 2/-2;

  margin-bottom: 30px;

  h1 {
    ${({ theme: { locale } }) => setTypography('heading1', locale)}
  }

  h2 {
    ${({ theme: { locale } }) => setTypography('heading2', locale)}
  }
  h3 {
    ${({ theme: { locale } }) => setTypography('heading3', locale)}
  }

  h4 {
    ${({ theme: { locale } }) => setTypography('heading4', locale)}
  }

  h5 {
    ${({ theme: { locale } }) => setTypography('heading5', locale)}
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    margin-bottom: 20px;

    ${mediaDesktop(css`
      margin-bottom: 24px;
    `)}
  }

  p {
    ${({ theme: { locale } }) => setTypography('body', locale)}
    margin-bottom: 30px;
  }

  ul {
    list-style-type: disc;
    -webkit-margin-before: 1em;
    -webkit-margin-after: 1em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    -webkit-padding-start: 25px;
  }
`;
